<template>
  <div>
    <Card>
      <Row class="search-con">
        <Col span="4">
          <Button @click="showAddModal" type="primary">添加</Button>
        </Col>
      </Row>
      <tables
        editable
        :columns="columns"
        v-model="tableData"
        :loading="tableLoading"
      />
      <Row class="page-con">
        <div class="page-bottom">
          <Page
            :current="page"
            :total="total"
            :page-size="pageSize"
            show-sizer
            show-elevator
            @on-change="changePage"
            @on-page-size-change="changePageSize"
          />
        </div>
      </Row>
    </Card>

    <Modal
      :mask-closable="false"
      v-model="addModal"
      title="添加"
      footer-hide>

      <forms :resetFlag="resetFlag"
      ref="add"  
      @on-ok="addSumit" @on-cancel="cancel" />
    </Modal>

    <Modal
      :mask-closable="false"
      v-model="editModal"
      title="编辑"
      footer-hide
      >
      <forms :resetFlag="resetFlag"
      ref="edit"  
      @on-ok="editSumit" @on-cancel="cancel" />
    </Modal>
  </div>
</template>

<script>
import Tables from "_c/tables/table-only.vue";
import Forms from "./add_advertisement_library_form.vue";
import { getAdvertisementLibrary, add_advertisement_library, delete_advertisement_library, edit_advertisement_library, getClassifys} from "@/api/data";

import config from '@/config'
const baseUrl = process.env.NODE_ENV === 'development' ? config.baseUrl.dev : config.baseUrl.pro

export default {
  name: "finance",
  components: {
    Tables,
    Forms,
  },
  data() {
    return {
      page: 1,
      total: 0,
      pageSize: 10,

      addModal: false,
      editModal: false,
      resetFlag: false,
      editData: {},
      tableLoading: true,
      allMoney: 0.0,
      startTime: "",
      endTime: "",
      columns: [
        {type: 'index', title: '序号',width: 100, align: "center"},
        { title: "名称" , key: "advertisement_desc", editable: true },
        { title: "产品分类" , key: "classify_name", editable: true },
        { title: "视频" , key: "url", editable: true, align: "center",
          render: (h, params) => {
            return params.row.url != '' ?h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "primary",
                    size: "small",
                  },
                  style: {
                    marginRight: "5px",
                  },
                  on: {
                    click: () => {
                      this.download(baseUrl =='https://in.sinano-ai.com/api'? params.row.id_url: params.row.url);
                    },
                  },
                },
                "下载"
              )
            ]): h('span', '');
          },
        },
        { title: "分辨率" , key: "resolving_power", editable: true, align: "center"},
        { title: "创建时间", key: "create_time", editable: true },
        {
          title: "Handle",
          key: "handle",width: 200,
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "text",
                    size: "small",
                  },
                  style: {
                    marginRight: "5px",
                  },
                  on: {
                    click: () => {
                      this.showEditModal(params);
                    },
                  },
                },
                "编辑"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "text",
                    size: "small",
                  },
                  style: {
                    marginRight: "5px",
                  },
                  on: {
                    click: () => {
                      this.handleDelete(params);
                    },
                  },
                },
                "删除"
              ),
            ]);
          },
        }
      ],
      tableData: [],
    };
  },
  methods: {
    download(url){
      window.open(url, '_blank');
    },
    showAddModal() {
      this.addModal = true;
      this.resetFlag = !this.resetFlag;
      getClassifys().then((res) => {
        var classifyIds = res.data.data.records;
        this.$refs.add.setClassifyData(classifyIds);
      });
    },
    showEditModal(params) {
      this.editData = params.row;
      this.editModal = true;
      getClassifys().then((res) => {
        var classifyIds = res.data.data.records;
        this.$refs.edit.setClassifyData(classifyIds);
      });
      this.$refs.edit.setEditData(this.editData)
    },
    addSumit(formValidate) {
      const data = {
        classify_id:formValidate.classify_id,
        desc:formValidate.name,
        url:formValidate.url,
        id_url:formValidate.id_url,
        resolving_power:formValidate.resolving_power,
      }
      add_advertisement_library(data)
        .then((res) => {
          if (res.data.code == 200) {
            this.$Message.success("成功!");
            this.addModal = false;
            this.handleSearch();
          } else {
            this.$Message.error(res.data.msg);
          }
        })
        .catch((err) => {
          this.$Message.error("失败!");
        });
    },
    editSumit(formValidate) {
      const data = {
        classify_id:formValidate.classify_id,
        desc:formValidate.name,
        url:formValidate.url,
        id_url:formValidate.id_url,
        resolving_power:formValidate.resolving_power,
      }
      edit_advertisement_library(data, formValidate.id)
        .then((res) => {
          if (res.data.code == 200) {
            this.$Message.success("成功!");
            this.editModal = false;
            this.handleSearch();
          } else {
            this.$Message.error(res.data.msg);
          }
        })
        .catch((err) => {
          this.$Message.error("失败!");
        });
    },
    cancel() {},
    changePage(page) {
      this.page = page;
      this.handleSearch();
    },
    changePageSize(pageSize) {
      this.pageSize = pageSize;
      this.handleSearch();
    },
    handleSearch() {
      this.setTableLoading(true);
      let params = {
        page: this.page,
        pageSize: this.pageSize
      };
      getAdvertisementLibrary(params).then((res) => {
        if (res.data.code == 200) {
          this.tableData = res.data.data.records;
          this.total = res.data.data.total;
        } else {
          this.tableData = [];
          this.total = 0;
        }
        this.setTableLoading(false);
      });
    },
    handleDelete(params) {
        this.$Modal.confirm({
            title: '提示',
            content: '<p>是否确认删除？</p>',
            onOk: () => {
              delete_advertisement_library(params.row.id)
                .then((res) => {
                    if (res.data.code == 200) {
                        this.tableData.splice(params.index, 1);
                        this.$Message.success("成功!");
                    } else {
                        this.$Message.error(res.data.msg);
                    }
                }).catch((err) => {
                    this.$Message.error("失败!");
                });
            },
            onCancel: () => {
                this.$Message.info('已取消');
            }
        });
    },
    setTableLoading(state) {
      this.tableLoading = state;
    },
  },
  mounted() {
    this.handleSearch();
  },
};
</script>
